import { ExternalSmsMarketingProvider } from "@redotech/redo-model/marketing";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const setExternalSmsMarketingProvider = {
  name: "setExternalSmsMarketingProvider" as const,
  input: z.object({
    provider: createEnum(ExternalSmsMarketingProvider).nullable(),
  }),
  output: z.object({
    success: z.boolean(),
  }),
};
